// extracted by mini-css-extract-plugin
export default {"menu-nav-disabled":"navbox_menu-nav-disabled__mVSb1","nav-img":"navbox_nav-img__xo6t3"};